import script from "./LegislationManagementView.vue?vue&type=script&setup=true&lang=js"
export * from "./LegislationManagementView.vue?vue&type=script&setup=true&lang=js"

import "./LegislationManagementView.vue?vue&type=style&index=0&id=0dd20f16&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0dd20f16"]])

export default __exports__